<div class="d-flex flex-column gap-4">
  <div class="d-flex flex-column gap-5" [formGroup]="internalForm">
    <div formArrayName="configurations" class="d-flex flex-column gap-5">
      @for (configGroup of configurations.controls; track i; let i = $index) {
        <fieldset [formGroupName]="i" class="config-container">
          <legend>{{ 'page.widgetContent.addEditDialog.itemCategory' | translate }} {{ i + 1 }}</legend>
          <div class="d-flex justify-content-end pb-2">
            @if (i !== 0) {
              <button
                mat-mini-fab
                color="primary"
                type="button"
                (click)="removeConfiguration(i)"
                [matTooltip]="'button.remove' | translate"
                matTooltipPosition="left"
              >
                <mat-icon>delete</mat-icon>
              </button>
            }
          </div>
          <div class="d-flex flex-column gap-3">
            <div class="d-flex gap-5 align-items-center w-100 equal-width">
              <mat-dropdown
                [formControl]="$any(configGroup).get('itemCategory')"
                [options]="(itemCategories$ | async) ?? []"
                [configurationInput]="itemCategoryDropdownConfiguration"
                [isFormSubmitted]="isFormSubmitted()"
              ></mat-dropdown>

              <mat-form-field appearance="outline">
                <mat-label>{{ 'page.widgetContent.addEditDialog.middleTitle' | translate }}</mat-label>
                <input matInput [formControl]="$any(configGroup).get('itemCategoryName')" maxlength="3" />
                <mat-error [control]="$any(configGroup).controls.itemCategoryName"></mat-error>
              </mat-form-field>

              <mat-dropdown
                [formControl]="$any(configGroup).get('option')"
                [options]="options"
                [configurationInput]="optionDropdownConfiguration"
                [isFormSubmitted]="isFormSubmitted()"
              ></mat-dropdown>
            </div>

            <div class="d-flex flex-column gap-3">
              @for (shiftGroup of getShiftGroups(i).controls; track j; let j = $index) {
                <div class="d-flex gap-5 align-items-center w-100 equal-width">
                  <mat-dropdown
                    [formControl]="$any(shiftGroup).get('shift')"
                    [options]="(shifts$ | async) ?? []"
                    [configurationInput]="shiftDropdownConfiguration"
                    [isFormSubmitted]="isFormSubmitted()"
                  ></mat-dropdown>

                  <mat-form-field appearance="outline">
                    <mat-label>{{ 'page.widgetContent.addEditDialog.middleTitle' | translate }} {{ j + 1 }}</mat-label>
                    <input matInput [formControl]="$any(shiftGroup).controls.shiftName" maxlength="3" />
                    <mat-error [control]="$any(shiftGroup).controls.shiftName"></mat-error>
                  </mat-form-field>
                </div>
              }
            </div>

            <div class="d-flex flex-column gap-2 pb-2">
              <mat-dropdown
                [formControl]="$any(configGroup).get('redStatusCategories')"
                [options]="redStatusCategoryOptions"
                [configurationInput]="redStatusCategoryDropdownConfiguration"
                [isFormSubmitted]="isFormSubmitted()"
              ></mat-dropdown>

              <app-info-message
                [text]="'page.widgetContent.addEditDialog.redStatusCategoriesDisclaimer' | translate"
              ></app-info-message>
            </div>
          </div>
        </fieldset>
      }
    </div>
  </div>
  <div class="d-flex justify-content-start pt-3 pb-3">
    <button mat-stroked-button type="button" (click)="addConfiguration()">
      <mat-icon>add</mat-icon>
      {{ 'button.addContext' | translate: { context: ('filterCard.itemCategory' | translate) } }}
    </button>
  </div>
</div>
